class ProductVariantBuilder extends HTMLElement {
  API_END_POINT = 'https://csv-importer-prod-700544005264.us-central1.run.app';
  color_swatches = [
    { name: 'hardware_finish', title: 'Hardware Finish' },
    { name: 'glass_type', title: 'Glass Type' },
  ];
  additionalFilters = [
    { name: 'height', title: 'Height' },
    { name: 'width', title: 'Width' },
    { name: 'depth', title: 'Depth' },
    { name: 'door_width', title: 'Door Width' },
    { name: 'door_opens', title: 'Door Opening' },
    { name: 'extras', title: 'Extras' },
  ];
  //  stores the available options
  availableFilterValues = [
    { name: 'glass_type', values: [] },
    { name: 'height', values: [] },
    { name: 'width', values: [] },
    { name: 'depth', values: [] },
    { name: 'door_width', values: [] },
    { name: 'door_opens', values: [] },
    { name: 'extras', values: [] },
  ];
  // stores number of active variant options apart from HF
  variantOptions = {};
  getProductTriggers = [];
  defaultVariant = {};

  constructor() {
    super();
  }

  connectedCallback() {
    this.handleVariantOptions();
  }

  handleVariantOptions() {
    const product_sku = this.getAttribute('display_sku');
    const api_url = `${this.API_END_POINT}/getparentproductoptions`;

    const filterConditions = {
      sku: product_sku,
    };
    console.log('display_sku', product_sku);
    fetch(api_url, {
      method: 'POST', // HTTP method
      headers: {
        'Content-Type': 'application/json', // Specify JSON content
      },
      body: JSON.stringify(filterConditions),
    })
      .then((response) => {
        console.log('response variants', response);
        if (!response.ok) {
          throw new Error('Could not load product variants');
        }
        return response.json();
      })
      .then((result) => {
        this.variantOptions = result.data;
        this.render();
      });
  }

  render() {
    this.innerHTML = ''; // Clear any existing content

    const colorGroupEl = document.createElement('div'); // for 1 and 2
    colorGroupEl.classList.add('color-group');

    this.color_swatches.forEach((optionType) => {
      let options = this.variantOptions[optionType.name];

      // Hardware finish and product type starts here
      if (options && options.length > 0) {
        this.getProductTriggers.push(optionType.name);
        console.log({ getProductTriggers: this.getProductTriggers });
        // Create a section for each option type
        const section = document.createElement('div');
        section.classList.add('product-option-group');
        section.classList.add('product-option-swatch');

        // Add title for the option group
        const title = document.createElement('h3');
        title.textContent = `${optionType.title}:`;
        section.appendChild(title);

        //added options-area
        const optionsAreaEl = document.createElement('div');
        optionsAreaEl.classList.add('options-area');

        //Add label
        const colorLabelEl = document.createElement('label');
        colorLabelEl.classList.add('color-tag', optionType.name);
        colorLabelEl.textContent = ` `;
        optionsAreaEl.appendChild(colorLabelEl);

        // Create a container div for the radio buttons with the input-color-radio-group class
        const radioGroup = document.createElement('div');
        radioGroup.classList.add('input-color-radio-group', `${optionType.name}-area`);

        // Create radio buttons for color swatch options
        options.forEach((option, index) => {
          const colorOption = option.trim(); // this is basically the color of the option

          const label = document.createElement('label');
          label.classList.add('card-radio-btn', 'color-radio');
          label.title = this.getColorLabel(colorOption);

          const input = document.createElement('input');
          input.type = 'radio';
          input.name = optionType.name; // Each group has a unique name
          input.classList.add('card-input-element', 'd-none');
          input.id = `${optionType.name}-${index}`;
          input.value = colorOption;

          // Set the first option as checked by default
          if (index === 0) {
            input.checked = true;
          }
          const outerDivEl = document.createElement('div');
          outerDivEl.classList.add('outer-div');

          // Add a div for the custom styled radio body
          const div = document.createElement('button');
          div.classList.add('radio-card-body');
          div.classList.add('color-card-body');
          div.style.backgroundColor = colorOption;
          div.style.padding = 0;

          outerDivEl.appendChild(div);
          // Append input and div to the label
          label.appendChild(input);
          label.appendChild(outerDivEl);

          // Append the label to the radio group container
          radioGroup.appendChild(label);
        });

        // Append the radio group to the options area
        optionsAreaEl.appendChild(radioGroup);
        section.appendChild(optionsAreaEl);

        // Add a change event listener to handle selection for this option type
        section.addEventListener('click', (event) => {
          const parentLabel = event.target.closest('.card-radio-btn');
          const radioInput = parentLabel.querySelector('.card-input-element');
          if (radioInput) {
            radioInput.checked = true; // Select the radio button
            if (optionType.name == 'hardware_finish') {
              // update hardware_finish label
              const hardware_finishLabelEl = document.querySelector('.color-tag.hardware_finish');
              hardware_finishLabelEl.textContent = this.getColorLabel(radioInput.value);
              const labelElement = document.querySelector('label.color-tag.glass_type');

              if (labelElement) {
                labelElement.innerText = '';
              }
            }
            if (optionType.name == 'glass_type') {
              // update hardware_finish label
              const glass_typeLabelEl = document.querySelector('.color-tag.glass_type');
              glass_typeLabelEl.textContent = this.getColorLabel(radioInput.value);
            }
          }
          this.onChangeFilterOption(event, optionType.name);
        });

        colorGroupEl.appendChild(section);
      }
      // Hardware finish and product type end here
    });
    this.appendChild(colorGroupEl);
    //this.appendChild(hrElement);
    // Loop through each option type
    this.additionalFilters.forEach((optionType) => {
      let options = this.variantOptions[optionType.name];

      if (options.length == 1 && options[0] == 'None') {
        options = [];
      }

      // for options in an additional filter
      if (options && options.length > 0) {
        this.getProductTriggers.push(optionType.name);
        // Create a section for each option type
        const section = document.createElement('div');
        section.classList.add('product-option-group');
        section.classList.add('product-option-select');

        // Add title for the option group
        const title = document.createElement('h3');
        title.textContent = `${optionType.title}:`;
        section.appendChild(title);

        // ----
        // DESKTOP
        // ----

        // Create a container div for the radio buttons with the input-radio-group class
        const radioGroup = document.createElement('div');
        // each section will have a specific class names associated with it
        radioGroup.classList.add('input-radio-group', `${optionType.name}-area`);

        options.forEach((option, index) => {
          const colorOption = option.trim();

          const label = document.createElement('label');
          label.classList.add('card-radio-btn');

          const input = document.createElement('input');
          input.type = 'radio';
          input.name = optionType.name; // Each group has a unique name
          input.classList.add('card-input-element', 'd-none');
          input.id = `${optionType.name}-${index}`;
          if (option === 'None') {
            input.value = null;
          } else {
            input.value = colorOption;
          }

          // Set the first option as checked by default
          if (index === 0) {
            input.checked = true;
          }

          // Add a div for the custom styled radio body
          const div = document.createElement('button');
          div.classList.add('radio-card-body');
          div.textContent = `${colorOption}`;

          // Append input and div to the label
          label.appendChild(input);
          label.appendChild(div);

          // Append the label to the radio group container
          radioGroup.appendChild(label);
        });

        // Append the radio group to the section
        section.appendChild(radioGroup);

        // Add a change event listener to handle selection for the radio buttons
        section.addEventListener('click', (event) => {
          const parentLabel = event.target.closest('.card-radio-btn');
          const radioInput = parentLabel?.querySelector('.card-input-element');
          if (radioInput) {
            radioInput.checked = true; // Select the radio button
          }
          this.onChangeFilterOption(event, optionType.name);
        });

        this.appendChild(section);

        // ----
        // MOBILE
        // ----

        // Create a dropdown for the same filter
        const dropdown = document.createElement('select');
        dropdown.classList.add('filter-dropdown', `dropdown-${optionType.name}-area`, 'custom-dropdown');
        // dropdown.classList.add('filter-dropdown');
        dropdown.name = `${optionType.name}-dropdown`;

        // options for the dropdown filters
        options.forEach((dropdownOption) => {
          const optionElement = document.createElement('option');
          optionElement.value = dropdownOption;
          optionElement.textContent = dropdownOption;
          dropdown.appendChild(optionElement);
        });

        // Append the dropdown to the section
        section.appendChild(dropdown);

        // Add a change event listener to handle selection for the dropdown
        dropdown.addEventListener('change', (event) => {
          console.log(`Dropdown value for ${optionType.name} changed to:`, event.target.value);
          // get relative options button
          const relativeOptionsEl = document.querySelector(
            `input[name="${optionType.name}"][value="${CSS.escape(event.target.value)}"]`,
          );
          if (relativeOptionsEl) relativeOptionsEl.checked = true;
          this.onChangeFilterOption(event, optionType.name);
        });
      }

      if (options && options.length > 0) {
        // this.getProductTriggers.push(optionType.name);
        // Create a section for each option type
        // const section = document.createElement('div');
        // section.classList.add('mobile-product-option-group');
        // // Add title for the option group
        // const title = document.createElement('h3');
        // title.textContent = `${optionType.title}:`;
        // section.appendChild(title);
        // // Create a dropdown for the same filter
        // const dropdown = document.createElement('select');
        // dropdown.classList.add('filter-dropdown', `dropdown-${optionType.name}-area`, 'custom-dropdown');
        // // dropdown.classList.add('filter-dropdown');
        // dropdown.name = `${optionType.name}-dropdown`;
        // // options for the dropdown filters
        // options.forEach((dropdownOption) => {
        //   const optionElement = document.createElement('option');
        //   optionElement.value = dropdownOption;
        //   optionElement.textContent = dropdownOption;
        //   dropdown.appendChild(optionElement);
        // });
        // // Append the dropdown to the section
        // section.appendChild(dropdown);
        // // Add a change event listener to handle selection for the dropdown
        // dropdown.addEventListener('change', (event) => {
        //   console.log(`Dropdown value for ${optionType.name} changed to:`, event.target.value);
        //   // get relative options button
        //   const relativeOptionsEl = document.querySelector(
        //     `input[name="${optionType.name}"][value="${CSS.escape(event.target.value)}"]`
        //   );
        //   if (relativeOptionsEl) relativeOptionsEl.checked = true;
        //   this.onChangeFilterOption(event, optionType.name);
        // });
        // // Append the section to the component
        // this.appendChild(section);
      }
      // Additional filters end here
    });

    this.afterLoadFunction();
  }
  onChangeFilterOption(event, optionName) {
    console.log({ event, optionName });
    const addToCartButton = document.querySelector('button[name="add"]');
    addToCartButton.disabled = true;
    const parentProductTitle = this.getAttribute('product_title');

    // Whenever someone resets a filter we wil change the product title to the parent product title
    document.querySelectorAll('#vb__product__title').forEach((element) => {
      element.textContent = parentProductTitle;
    });

    //  Get options basically fetches the options for the filter immediately after it

    if (optionName == 'hardware_finish') {
      this.getFilterOptions('glass_type');
    }

    if (optionName == 'glass_type') {
      this.getFilterOptions('height');
    }
    if (optionName == 'height') {
      this.getFilterOptions('width');
    }

    if (optionName == 'width') {
      if (this.getProductTriggers.includes('depth')) {
        this.getFilterOptions('depth');
      } else if (this.getProductTriggers.includes('door_width')) {
        this.getFilterOptions('door_width');
      } else if (this.getProductTriggers.includes('door_opens')) {
        this.getFilterOptions('door_opens');
      } else if (this.getProductTriggers.includes('extras')) {
        this.getFilterOptions('extras');
      }
    }
    if (optionName == 'depth') {
      if (this.getProductTriggers.includes('door_width')) {
        this.getFilterOptions('door_width');
      } else if (this.getProductTriggers.includes('door_opens')) {
        this.getFilterOptions('door_opens');
      } else if (this.getProductTriggers.includes('extras')) {
        this.getFilterOptions('extras');
      }
    }
    if (optionName == 'door_width') {
      if (this.getProductTriggers.includes('door_opens')) {
        this.getFilterOptions('door_opens');
      } else if (this.getProductTriggers.includes('extras')) {
        this.getFilterOptions('extras');
      }
    }
    if (optionName == 'door_opens') {
      if (this.getProductTriggers.includes('extras')) {
        this.getFilterOptions('extras');
      }
    }
    // Whenever I am in the last filter, the add to cart button will be activated
    const select_index = this.getProductTriggers.indexOf(optionName);
    if (select_index === this.getProductTriggers.length - 1) {
      const addToCartButton = document.querySelector('button[name="add"]');
      addToCartButton.disabled = false;
      this.handleOptionSelect(event, optionName);
    }

    console.log('event', event, optionName);
  }
  getFilterOptions(type) {
    console.log('getting new filter options');
    const product_sku = this.getAttribute('parent_product_sku');
    const hardware_finish = document.querySelector(`input[name="hardware_finish"]:checked`);
    const glass_type = document.querySelector(`input[name="glass_type"]:checked`);
    const height = document.querySelector(`input[name="height"]:checked`);
    const width = document.querySelector(`input[name="width"]:checked`);
    const depth = document.querySelector(`input[name="depth"]:checked`);
    const door_width = document.querySelector(`input[name="door_width"]:checked`);
    const door_opens = document.querySelector(`input[name="door_opens"]:checked`);

    const hardware_finish_value = hardware_finish ? hardware_finish.value : null;
    const glass_type_value = glass_type ? glass_type.value : null;
    const height_value = height ? height.value : null;
    const width_value = width ? width.value : null;
    const depth_value = depth ? depth.value : null;
    const door_width_value = door_width ? door_width.value : null;
    const door_opens_value = door_opens ? door_opens.value : null;

    const api_url = `${this.API_END_POINT}/getproductoptions`;

    const filterConditions = {
      hardware_finish: hardware_finish_value,
      height: height_value,
      glass_type: glass_type_value,
      parent_product_sku: product_sku,
      width: width_value,
      depth: depth_value,
      door_width: door_width_value,
      door_opens: door_opens_value,
      type: type,
    };

    fetch(api_url, {
      method: 'POST', // HTTP method
      headers: {
        'Content-Type': 'application/json', // Specify JSON content
      },
      body: JSON.stringify(filterConditions),
    })
      .then((response) => {
        if (!response.ok) {
          return;
        }
        return response.json();
      })
      .then((result) => {
        this.availableFilterValues = result.data;
        if (type == 'glass_type') {
          this.optionsBuilder(result.data.glass_type, `${type}-area`, type);
        }
        if (type == 'height') {
          this.optionsBuilder(result.data.height, `${type}-area`, type);
        }
        if (type == 'width') {
          this.optionsBuilder(result.data.width, `${type}-area`, type);
        }
        if (type == 'depth') {
          this.optionsBuilder(result.data.depth, `${type}-area`, type);
        }
        if (type == 'door_width') {
          this.optionsBuilder(result.data.door_width, `${type}-area`, type);
        }
        if (type == 'door_opens') {
          this.optionsBuilder(result.data.door_opens, `${type}-area`, type);
        }
        if (type == 'extras') {
          this.optionsBuilder(result.data.extras, `${type}-area`, type);
        }

        console.log('result', result, this.availableFilterValues, type);
      });
  }

  optionsBuilder(optionsAlow, className, type) {
    let options = this.variantOptions[type];

    if (options.length == 1 && options[0] == 'None') {
      options = [];
    }

    const radioGroup = document.querySelector(`.${className}`);
    const dropdownComponent = document.querySelector(`.dropdown-${className}`);

    this.resetRelatedOptions(type);

    if (radioGroup || dropdownComponent) {
      const empty_option_labelEl = radioGroup.querySelector('.empty_option_label');
      if (empty_option_labelEl) {
        empty_option_labelEl.remove();
      }
      const labels = radioGroup.querySelectorAll('.card-radio-btn');
      if (labels) {
        labels.forEach((label) => {
          label.remove();
        });
      }
      if (dropdownComponent) {
        dropdownComponent.innerHTML = '';
        dropdownComponent.disabled = false;
        const placeholderOption = document.createElement('option');
        placeholderOption.value = '';
        placeholderOption.textContent = '--';
        placeholderOption.disabled = true;
        placeholderOption.selected = true;
        dropdownComponent?.appendChild(placeholderOption);
      }

      if (options == undefined || options.length == 0) {
        const labelEl = document.createElement('label');
        labelEl.classList.add('empty_option_label', type);
        labelEl.textContent = `Make selection above to populate.`;
        radioGroup.appendChild(labelEl);
      }

      if (type == 'glass_type') {
        // Create radio buttons for each option
        options.forEach((option, index) => {
          const colorOption = option.trim();

          const label = document.createElement('label');
          label.classList.add('card-radio-btn', 'color-radio');
          label.title = this.getColorLabel(colorOption);

          const input = document.createElement('input');
          input.type = 'radio';
          input.name = type; // Each group has a unique name
          input.classList.add('card-input-element', 'd-none');
          input.id = `${type}-${index}`;
          input.value = colorOption;

          const outerDivEl = document.createElement('div');
          outerDivEl.classList.add('outer-div');

          // Add a div for the custom styled radio body
          const btn = document.createElement('button');
          btn.classList.add('radio-card-body');
          btn.classList.add('color-card-body');
          btn.style.backgroundColor = colorOption;
          btn.style.padding = 0;
          outerDivEl.appendChild(btn);
          // Append input and div to the label
          label.appendChild(input);
          label.appendChild(outerDivEl);

          // Append the label to the radio group container
          radioGroup.appendChild(label);
        });
      } else {
        options.forEach((option, index) => {
          const colorOption = option.trim();

          const label = document.createElement('label');
          label.classList.add('card-radio-btn');

          const input = document.createElement('input');
          input.type = 'radio';
          input.name = type; // Each group has a unique name
          input.classList.add('card-input-element', 'd-none');
          input.id = `${type}-${index}`;
          if (option === 'None') {
            input.value = null;
          } else {
            input.value = colorOption;
          }

          // This is where we are disabling the radio options that are not available
          const btn = document.createElement('button');
          btn.classList.add('radio-card-body');
          btn.textContent = `${colorOption}`;
          if (!optionsAlow.includes(colorOption)) {
            btn.disabled = true;
            btn.style.opacity = 0.3;
            btn.style.cursor = 'auto';
          } else {
            btn.disabled = false;
            btn.style.opacity = 1;
            btn.style.cursor = 'pointer';
          }

          // Append input and div to the label
          label.appendChild(input);
          label.appendChild(btn);

          // Append the label to the radio group container
          radioGroup.appendChild(label);

          // Dropdown (Mobile)
          const dropdownOption = document.createElement('option');
          dropdownOption.value = option === 'None' ? '' : colorOption;
          dropdownOption.textContent = colorOption;
          if (!optionsAlow.includes(colorOption)) {
            dropdownOption.disabled = true;
          }
          dropdownComponent?.appendChild(dropdownOption);
        });

        dropdownComponent.addEventListener('change', (event) => {
          console.log(`Dropdown value for ${type} changed to:`, event.target.value);
          // get relative options button
          const relativeOptionsEl = document.querySelector(
            `input[name="${type}"][value="${CSS.escape(event.target.value)}"]`,
          );
          if (relativeOptionsEl) relativeOptionsEl.checked = true;
          this.onChangeFilterOption(event, type);
        });
      }

      const buttons = document.querySelectorAll(`input[name="${type}"]`);
      buttons.forEach((button) => {
        button.checked = false;
      });
    }
  }
  resetRelatedOptions(type) {
    const index = this.getProductTriggers.indexOf(type);
    if (index === -1) {
      return [];
    }
    const getExisting = this.getProductTriggers.slice(index + 1);
    console.log('getExisting', getExisting);
    getExisting.forEach((existing) => {
      const radioGroup = document.querySelector(`.${existing}-area`);
      const labels = radioGroup.querySelectorAll('.card-radio-btn');
      const empty_option_labelEl = radioGroup.querySelector('.empty_option_label');
      if (empty_option_labelEl) {
        empty_option_labelEl.remove();
      }
      if (labels) {
        labels.forEach((label) => {
          label.remove();
        });
        const labelEl = document.createElement('label');
        labelEl.classList.add('empty_option_label', existing);
        labelEl.textContent = `Make selection above to populate.`;
        // return
        radioGroup.appendChild(labelEl);
      }
      const dropdownComponent = document.querySelector(`.dropdown-${existing}-area`);
      if (dropdownComponent) {
        const disabledSelectComponent = document.createElement('select');
        disabledSelectComponent.classList.add('filter-dropdown');
        disabledSelectComponent.classList.add(`dropdown-${existing}-area`);
        disabledSelectComponent.classList.add('custom-dropdown');

        disabledSelectComponent.name = `${existing}-dropdown`;
        disabledSelectComponent.disabled = true;

        // Create the option element
        const option = document.createElement('option');
        option.value = '--';
        option.selected = true; // Set the option as selected
        option.textContent = '--'; // Set the display text

        // Append the option to the select element
        disabledSelectComponent.appendChild(option);
        dropdownComponent.replaceWith(disabledSelectComponent);
      }
    });
  }
  handleOptionSelect(event, optionName) {
    const api_url = `${this.API_END_POINT}/getproduct`;
    const productId = this.getAttribute('product_id');
    const hardware_finish = document.querySelector(`input[name="hardware_finish"]:checked`);
    const height = document.querySelector(`input[name="height"]:checked`);
    const width = document.querySelector(`input[name="width"]:checked`);
    const depth = document.querySelector(`input[name="depth"]:checked`);
    const door_opens = document.querySelector(`input[name="door_opens"]:checked`);
    const door_width = document.querySelector(`input[name="door_width"]:checked`);
    const extras = document.querySelector(`input[name="extras"]:checked`);
    const glass_type = document.querySelector(`input[name="glass_type"]:checked`);

    const hardware_finish_value = hardware_finish ? hardware_finish.value : null;
    const height_value = height ? height.value : null;
    const width_value = width ? width.value : null;
    const depth_value = depth ? depth.value : null;
    const door_opens_value = door_opens ? door_opens.value : null;
    const door_width_value = door_width ? door_width.value : null;
    const extras_value = extras ? extras.value : null;
    const glass_type_value = glass_type ? glass_type.value : null;
    const newEvent = event.target.closest('.card-radio-btn');
    const inputElement = newEvent?.querySelector('input.card-input-element');
    const product_sku = this.getAttribute('parent_product_sku');
    const dropdownName = event?.srcElement?.name;
    if (inputElement?.name === optionName || dropdownName == `${optionName}-dropdown`) {
      document.getElementById('aston-loader').style.display = 'flex';
      console.log(
        `Selected ${optionName}:`,
        event.target.value,
        productId,
        hardware_finish_value,
        door_opens_value,
        height_value,
        width_value,
        depth_value,
      );
      // Define filter conditions
      const filterConditions = {
        hardware_finish: hardware_finish_value,
        door_width: door_width_value != '' ? door_width_value : null,
        height: height_value,
        width: width_value,
        extras: extras_value != '' ? extras_value : null,
        //  parent_product_id: `gid://shopify/Product/${productId}`,
        parent_product_sku: product_sku,
        isParentProduct: false,
        glass_type: glass_type_value,
        depth: depth_value != '' ? depth_value : null,
        door_opens: door_opens_value != '' ? door_opens_value : null,
      };
      console.log('filterConditions', filterConditions);
      this.fetchAndFilterProductVariants(api_url, filterConditions, event);
    }
  }
  fetchAndFilterProductVariants(api_url, filterConditions, event) {
    fetch(api_url, {
      method: 'POST', // HTTP method
      headers: {
        'Content-Type': 'application/json', // Specify JSON content
      },
      body: JSON.stringify(filterConditions),
    })
      .then((response) => {
        if (!response.ok) {
          document.getElementById('aston-loader').style.display = 'none';
          const addToCartButton = document.querySelector('button[name="add"]');
          addToCartButton.disabled = true;
          // const buyNowButton = document.querySelector('button[name="buy_now"]');
          // buyNowButton.disabled = true;
          const errorMessageEl = document.getElementById('not-fount-error');
          errorMessageEl.textContent =
            '* The product configuration you have selected is not possible. Please make a new selection.';
          errorMessageEl.style.display = 'block';
          document
            .querySelectorAll('.card-input-element+.radio-card-body')
            .forEach((el) => (el.style.borderColor = '#070E3E66'));
          event.target.closest('label').querySelector('.radio-card-body').style.borderColor = 'red';
        }
        return response.json();
      })
      .then((filteredProduct) => {
        // Log the filtered result
        if (filteredProduct.success) {
          console.log('Found product:', filteredProduct);
          this.getProductInformation(filteredProduct.data.product_handle, event);

          document.getElementById('not-fount-error').style.display = 'none';
          const addToCartButton = document.querySelector('button[name="add"]');
          addToCartButton.disabled = false;
          // const buyNowButton = document.querySelector('button[name="buy_now"]');
          // buyNowButton.disabled = false;
          document
            .querySelectorAll('.card-input-element+.radio-card-body')
            .forEach((el) => (el.style.borderColor = '#070E3E66'));
          document.querySelectorAll('.color-card-body').forEach((el) => (el.style.borderColor = '#070E3E66'));
          document
            .querySelectorAll('.card-input-element:checked+.radio-card-body')
            .forEach((el) => (el.style.borderColor = '#070E3E66'));
        } else {
          document.getElementById('aston-loader').style.display = 'none';
          const addToCartButton = document.querySelector('button[name="add"]');
          addToCartButton.disabled = true;
          // const buyNowButton = document.querySelector('button[name="buy_now"]');
          // buyNowButton.disabled = true;
          const errorMessageEl = document.getElementById('not-fount-error');
          errorMessageEl.textContent =
            '* The product configuration you have selected is not possible. Please make a new selection.';
          errorMessageEl.style.display = 'block';
          document
            .querySelectorAll('.card-input-element+.radio-card-body')
            .forEach((el) => (el.style.borderColor = '#070E3E66'));
          event.target.closest('label').querySelector('.radio-card-body').style.borderColor = 'red';
          console.log('No product found matching the criteria');
        }
      })
      .catch((error) => {
        document.getElementById('aston-loader').style.display = 'none';
        console.error('Error loading or processing productvariants.json:', error);
      });
  }

  getProductInformation(handle, event) {
    // Define the store URL and access token
    const accessToken = '9baebcffd078a80c3be9970e464168be';
    // GraphQL query to get product details by handle
    const query = `
      query ProductByHandle {
        productByHandle(handle: "${handle.toLowerCase()}") {
          handle
          id
          title
          vendor
          productType
          totalInventory
          tags
          variants(first: 1) {
            nodes {
                  id
                  availableForSale
                  barcode
                  sku
                  taxable
                  product {
                      id
                  }
                  quantityAvailable
                  price {
                      amount
                      currencyCode
                  }
                  compareAtPrice {
                      amount
                      currencyCode
                  }
              }
          }
          featuredImage {
              altText
              height
              id
              originalSrc
              src
              transformedSrc
              url
              width
          }
          media(first: 10) {
              nodes {
                  alt
                  id
                  mediaContentType
              }
          }
          images(first: 10) {
              nodes {
                  altText
                  height
                  id
                  originalSrc
                  src
                  transformedSrc
                  url
                  width
              }
          }
          seo {
              description
              title
          }
          metafields(
              identifiers: [
                  { namespace: "custom", key: "style" },
                  { namespace: "custom", key: "product_type" },
                  { namespace: "custom", key: "parent_sku" },
                  { namespace: "custom", key: "default_display_sku" },
                  { namespace: "custom", key: "product_description" },
                  { namespace: "custom", key: "installation_manual_pdf" },
                  { namespace: "custom", key: "specifiation" },
                  { namespace: "custom", key: "glass_type" },
                  { namespace: "custom", key: "glass_type_color" },
                  { namespace: "custom", key: "hardware_finish" },
                  { namespace: "custom", key: "hardware_finish_color" },
                  { namespace: "custom", key: "depth" },
                  { namespace: "custom", key: "height" },
                  { namespace: "custom", key: "width" },
                  { namespace: "custom", key: "out_of_plumb_adjust" },
                  { namespace: "custom", key: "door_opens" },
                  { namespace: "custom", key: "extras" },
                  { namespace: "custom", key: "door_type" },
                  { namespace: "custom", key: "isparentproduct" },
                  { namespace: "custom", key: "door_width" }
              ]
          ) {
              id
              key
              value
              type
          }
      }
  }`;

    fetch(`/api/2024-10/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken,
      },
      body: JSON.stringify({ query }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data.productByHandle == null) {
          document.getElementById('not-fount-error').style.display = 'block';
          const addToCartButton = document.querySelector('button[name="add"]');
          addToCartButton.disabled = true;
          // const buyNowButton = document.querySelector('button[name="buy_now"]');
          // buyNowButton.disabled = true;
          document.getElementById('not-fount-error').textContent =
            '* The product configuration you have selected is not possible. Please make a new selection';
          document.getElementById('aston-loader').style.display = 'none';
          return;
        }

        const mappedData = this.mapProductData(data);

        if (mappedData.totalInventory < 1 && event != undefined) {
          document.getElementById('not-fount-error').textContent =
            '* This product configuration is out of stock. Please make a new selection or check back again soon.';
          document.getElementById('not-fount-error').style.display = 'block';
          const addToCartButton = document.querySelector('button[name="add"]');
          addToCartButton.disabled = true;
          // const buyNowButton = document.querySelector('button[name="buy_now"]');
          // buyNowButton.disabled = true;
          document
            .querySelectorAll('.card-input-element+.radio-card-body')
            .forEach((el) => (el.style.borderColor = '#070E3E66'));
          event.target.closest('label').querySelector('.radio-card-body').style.borderColor = 'red';
        }

        this.updatePageDom(mappedData);
        console.log('variant-product', mappedData);
        return mappedData;
      })
      .catch((error) => {
        document.getElementById('aston-loader').style.display = 'none';
        console.error('Error fetching product data:', error);
      });
  }

  // New function to execute any logic after load
  afterLoadFunction() {
    const default_display_handle = this.getAttribute('default_display_handle');

    const transformed_handle = default_display_handle.toLowerCase().replace(/\./g, ' ').replace(/\s+/g, '-');
    console.log('this.getProductTriggers', this.getProductTriggers);
    const getProductInformation = this.getProductInformation(transformed_handle);
    console.log('ProductVariantBuilder has completely loaded.', getProductInformation);

    // Additional actions you want to perform
  }

  updatePageDom(product) {
    const productId = product.id.match(/(\d+)$/)[0];
    const productSku = product.variants[0].sku;
    const variantProductId = product.variants[0].id.match(/(\d+)$/)[0];
    const price = product.variants[0].price;
    const compare_at_price = product.variants[0]?.compareAtPrice?.amount || 0;

    // const price_code = product.variants[0].presentmentPrices[0].price;
    // const compare_at_pricecode = product.variants[0].presentmentPrices[0].compareAtPrice;

    const metafields = {
      isparentproduct: product.metafields.find((meta) => meta.key === 'isparentproduct')?.jsonValue,
      default_display_sku: product.metafields.find((meta) => meta.key === 'default_display_sku')?.jsonValue,
      parent_sku: product.metafields.find((meta) => meta.key === 'parent_sku')?.jsonValue,
      style: product.metafields.find((meta) => meta.key === 'style')?.jsonValue,
      height: product.metafields.find((meta) => meta.key === 'height')?.jsonValue?.[0],
      width: product.metafields.find((meta) => meta.key === 'width')?.jsonValue?.[0],
      depth: product.metafields.find((meta) => meta.key === 'depth')?.jsonValue?.[0],
      door_opens: product.metafields.find((meta) => meta.key === 'door_opens')?.jsonValue?.[0],
      door_width: product.metafields.find((meta) => meta.key === 'door_width')?.jsonValue?.[0],
      extras: product.metafields.find((meta) => meta.key === 'extras')?.jsonValue?.[0],
      out_of_plumb_adjust: product.metafields.find((meta) => meta.key === 'out_of_plumb_adjust')?.jsonValue?.[0],
      hardware_finish: product.metafields.find((meta) => meta.key === 'hardware_finish_color')?.jsonValue?.[0],
      door_type: product.metafields.find((meta) => meta.key === 'door_type')?.jsonValue?.[0],
      glass_type: product.metafields.find((meta) => meta.key === 'glass_type_color')?.jsonValue?.[0],
      product_description: product.metafields.find((meta) => meta.key === 'product_description')?.jsonValue,
      specification: product.metafields.find((meta) => meta.key === 'specifiation')?.jsonValue,
      installation_manual_pdf: product.metafields.find((meta) => meta.key === 'installation_manual_pdf')?.jsonValue,
    };
    console.log('metafields', metafields);

    //TODO: need to refactor
    const api_url = `${this.API_END_POINT}/getdefaultproduct`;
    const filterConditions = {
      sku: productSku,
    };

    fetch(api_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filterConditions),
    })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error('Could not load productvariants.json');
        }
        const result = await response.json();

        if (!result?.success) {
          return;
        }

        this.defaultVariant = result.data;
        this.disableDefaultOptions(this.defaultVariant);
      })
      .catch((error) => {
        console.error('Fetch error:', error);
      });

    // Update the title
    document.querySelectorAll('#vb__product__title').forEach((element) => {
      element.textContent = product.title;
    });

    // Update sku
    document.querySelectorAll('#vb__product__sku').forEach((element) => {
      element.textContent = productSku;
    });

    // Update the price
    const currency = 'USD';
    const formattedMoney = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
    }).format(price);
    const priceSectionEl = document.querySelector('#vb__price__section');
    document.querySelectorAll('#vb__product__price').forEach((element) => {
      element.textContent = formattedMoney;
    });
    const compareAtPriceEl = document.querySelector('#vb__product__compare_at_price');
    const formattedCompareAtPrice = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
    }).format(compare_at_price);
    if (parseFloat(compare_at_price) > parseFloat(price)) {
      priceSectionEl.classList.add('price--on-sale');
      compareAtPriceEl.textContent = formattedCompareAtPrice;
    } else {
      priceSectionEl.classList.remove('price--on-sale');
    }

    //Update variant
    if (metafields.hardware_finish) {
      const hardware_finish = document.querySelector(
        `input[name="hardware_finish"][value="${CSS.escape(metafields.hardware_finish)}"]`,
      );
      hardware_finish.checked = true;

      // update hardware_finish label
      const hardware_finishLabelEl = document.querySelector('.color-tag.hardware_finish');
      hardware_finishLabelEl.textContent = this.getColorLabel(metafields.hardware_finish);
    }

    if (metafields.glass_type) {
      const glass_type = document.querySelector(
        `input[name="glass_type"][value="${CSS.escape(metafields.glass_type)}"]`,
      );
      glass_type.checked = true;

      const glass_typeLabelEl = document.querySelector('.color-tag.glass_type');
      glass_typeLabelEl.textContent = this.getColorLabel(metafields.glass_type);
    }

    if (metafields.height) {
      const height = document.querySelector(`input[name="height"][value="${CSS.escape(metafields.height)}"]`);
      height.checked = true;

      const dropdownComponent = document.querySelector('select[name="height-dropdown"]');
      if (dropdownComponent) dropdownComponent.value = metafields.height;
    }

    if (metafields.width) {
      const width = document.querySelector(`input[name="width"][value="${CSS.escape(metafields.width)}"]`);
      width.checked = true;

      const dropdownComponent = document.querySelector('select[name="width-dropdown"]');
      if (dropdownComponent) dropdownComponent.value = metafields.width;

      const inputRadioGroup = document.querySelector('.width-area');
    }

    if (metafields.door_opens) {
      const door_opens = document.querySelector(
        `input[name="door_opens"][value="${CSS.escape(metafields.door_opens)}"]`,
      );
      door_opens.checked = true;

      const dropdownComponent = document.querySelector('select[name="door_opens-dropdown"]');
      if (dropdownComponent) dropdownComponent.value = metafields.door_opens;
    }

    if (metafields.depth) {
      const depth = document.querySelector(`input[name="depth"][value="${CSS.escape(metafields.depth)}"]`);
      depth.checked = true;

      const dropdownComponent = document.querySelector('select[name="depth-dropdown"]');
      if (dropdownComponent) dropdownComponent.value = metafields.depth;
    }

    if (metafields.extras) {
      const extras = document.querySelector(`input[name="extras"][value="${CSS.escape(metafields.extras)}"]`);
      extras.checked = true;

      const dropdownComponent = document.querySelector('select[name="extras-dropdown"]');
      if (dropdownComponent) dropdownComponent.value = metafields.extras;
    }

    if (metafields.door_width) {
      const door_width = document.querySelector(
        `input[name="door_width"][value="${CSS.escape(metafields.door_width)}"]`,
      );
      door_width.checked = true;

      const dropdownComponent = document.querySelector('select[name="door_width-dropdown"]');
      if (dropdownComponent) dropdownComponent.value = metafields.door_width;
    }

    // Update Add to Cart
    document.querySelector('#vb__cart__product__id').value = variantProductId;

    // update buy button
    // document.querySelector('button[name="buy_now"]').dataset.productId = productId;

    // Update Product Description
    document.querySelectorAll('#vb__product__description').forEach((el) => {
      let dimensions = [];
      if (metafields.width) dimensions.push(metafields.width + ' W');
      if (metafields.height) dimensions.push(metafields.height + ' H');
      if (metafields.depth) dimensions.push(metafields.depth + ' D');
      if (metafields.door_width) dimensions.push(metafields.door_width + ' DW');

      const dimensionsText = dimensions.length > 0 ? '\nDimensions: ' + dimensions.join(' x ') : '';
      el.textContent = metafields.product_description + dimensionsText;
    });

    const toInnerHtml = (selector, escapedHtml) => {
      const decodeHtmlEntities = (html) => {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = html;
        return textarea.value;
      };

      // Decode the escaped HTML
      const decodedHtml = decodeHtmlEntities(escapedHtml);

      // Apply the decoded HTML to all matching elements
      document.querySelectorAll(selector).forEach((el) => {
        el.innerHTML = decodedHtml;
      });

      return decodedHtml; // Optionally return the decoded HTML if needed
    };

    toInnerHtml('#vb__product__specification', metafields.specification);
    // // Update Product specification
    // document.querySelectorAll('#vb__product__specification').forEach((el) => (el.innerHTML = metafields.specification));

    if (metafields.installation_manual_pdf) {
      // Update Product specification
      document
        .querySelectorAll('#vb__product__instalation_manual')
        .forEach((el) => (el.innerHTML = metafields.installation_manual_pdf));
    } else {
      document.querySelectorAll('#vb__product__instalation_manual_area').forEach((el) => (el.style.display = 'none'));
    }

    console.log('variantProductId', variantProductId);

    // Image handling
    const mainImageContainer = document.querySelector('.main-image-container img');
    const thumbnailsContainer = document.querySelector('.thumbnails-container');
    const images = product.images;

    if (images && images.length > 0) {
      mainImageContainer.src = images[0].src;
      mainImageContainer.alt = product.title;
      thumbnailsContainer.innerHTML = ''; // Clear existing thumbnails

      images.forEach((imageEdge, index) => {
        // skeleton loader
        const thumbnailWrapper = document.createElement('div');
        thumbnailWrapper.classList.add('thumbnail-wrapper');
        const skeleton = document.createElement('div');
        skeleton.classList.add('skeleton-loader');
        thumbnailWrapper.appendChild(skeleton);

        const thumbnail = document.createElement('img');
        thumbnail.classList.add('thumbnail-image');
        thumbnail.src = imageEdge.src.replace('_1024x1024', '_300x300');
        thumbnail.dataset.large = imageEdge.src;
        thumbnail.alt = imageEdge.altText || product.title;
        thumbnail.setAttribute('loading', 'eager');
        thumbnail.style.display = 'none';

        // replacing skeleton with the image once the it is loaded
        thumbnail.addEventListener('load', function () {
          skeleton.remove();
          thumbnail.style.display = '';
        });

        // Add click event for thumbnail
        thumbnail.addEventListener('click', function () {
          mainImageContainer.src = this.dataset.large;
          document.querySelectorAll('.thumbnail-image').forEach((img) => img.classList.remove('active'));
          this.classList.add('active');
        });

        if (index === 0) thumbnail.classList.add('active');
        thumbnailWrapper.appendChild(thumbnail);
        thumbnailsContainer.appendChild(thumbnailWrapper);
      });
    } else {
      mainImageContainer.src = 'placeholder-svg';
    }

    // Lightbox logic
    let currentImageIndex = 0;
    const lightboxOverlay = document.getElementById('lightbox-overlay');
    const lightboxImage = document.getElementById('lightbox-image');
    const lightboxClose = document.getElementById('lightbox-close');
    const lightboxPrev = document.getElementById('lightbox-prev'); // Left arrow button
    const lightboxNext = document.getElementById('lightbox-next'); // Right arrow button

    const openLightbox = (imageIndex) => {
      currentImageIndex = imageIndex;
      lightboxImage.src = images[imageIndex].src;
      lightboxOverlay.classList.remove('hidden');
    };

    const closeLightbox = () => {
      lightboxOverlay.classList.add('hidden');
    };

    const showPrevImage = () => {
      currentImageIndex = (currentImageIndex - 1 + images.length) % images.length;
      lightboxImage.src = images[currentImageIndex].src;
      mainImageContainer.src = images[currentImageIndex].src;
    };

    const showNextImage = () => {
      currentImageIndex = (currentImageIndex + 1) % images.length;
      lightboxImage.src = images[currentImageIndex].src;
      mainImageContainer.src = images[currentImageIndex].src;
    };

    mainImageContainer.addEventListener('click', () => openLightbox(currentImageIndex));

    // document.querySelectorAll('.thumbnail-image').forEach(thumbnail => {
    //   thumbnail.addEventListener('click', () => openLightbox(thumbnail.dataset.large));
    // });

    lightboxClose.addEventListener('click', closeLightbox);
    lightboxOverlay.addEventListener('click', (event) => {
      if (event.target === lightboxOverlay) closeLightbox();
    });

    lightboxPrev.addEventListener('click', showPrevImage);
    lightboxNext.addEventListener('click', showNextImage);

    document.getElementById('aston-loader').style.display = 'none';
  }
  // this is where we are disabling the radio buttons
  disableDefaultOptions(optionsAlow) {
    if (optionsAlow?.glass_type.length > 0) {
      const radioGroup = document.querySelector(`.glass_type-area`);
      const labels = radioGroup.querySelectorAll('.card-radio-btn');
      labels.forEach((label) => {
        const input = label.querySelector('.card-input-element');
        const button = label.querySelector('.radio-card-body');
        const inputValue = input.value;
        if (!optionsAlow.glass_type.includes(inputValue)) {
          button.disabled = true;
          button.style.opacity = 0.3;
          button.style.cursor = 'auto';
        } else {
          button.disabled = false;
          button.style.opacity = 1;
          button.style.cursor = 'pointer';
        }
      });
    }
    if (optionsAlow?.height.length > 0) {
      const radioGroup = document.querySelector(`.height-area`);
      const labels = radioGroup.querySelectorAll('.card-radio-btn');
      labels.forEach((label) => {
        const input = label.querySelector('.card-input-element');
        const button = label.querySelector('.radio-card-body');
        const inputValue = input.value;
        if (!optionsAlow.height.includes(inputValue)) {
          button.disabled = true;
          button.style.opacity = 0.3;
          button.style.cursor = 'auto';
        } else {
          button.disabled = false;
          button.style.opacity = 1;
          button.style.cursor = 'pointer';
        }
      });

      const dropdownComponent = document.querySelector(`.dropdown-height-area`);
      if (dropdownComponent) {
        // Iterate over each option in the dropdown
        Array.from(dropdownComponent.options).forEach((option) => {
          if (!optionsAlow.height.includes(option.value)) {
            // Disable the option
            option.disabled = true;

            // Alternatively, log a message for debugging
            console.log(`Option "${option.value}" is not allowed and has been disabled.`);
          } else {
            console.log(`Option "${option.value}" is allowed.`);
          }
        });
      } else {
        console.warn('Dropdown component not found.');
      }
    }
    if (optionsAlow?.width.length > 0) {
      const radioGroup = document.querySelector(`.width-area`);
      const labels = radioGroup.querySelectorAll('.card-radio-btn');
      labels.forEach((label) => {
        const input = label.querySelector('.card-input-element');
        const button = label.querySelector('.radio-card-body');
        const inputValue = input.value;
        if (!optionsAlow.width.includes(inputValue)) {
          button.disabled = true;
          button.style.opacity = 0.3;
          button.style.cursor = 'auto';
        } else {
          button.disabled = false;
          button.style.opacity = 1;
          button.style.cursor = 'pointer';
        }
      });
      const dropdownComponent = document.querySelector(`.dropdown-width-area`);
      if (dropdownComponent) {
        // Iterate over each option in the dropdown
        Array.from(dropdownComponent.options).forEach((option) => {
          if (!optionsAlow.width.includes(option.value)) {
            // Disable the option
            option.disabled = true;

            // Alternatively, log a message for debugging
            console.log(`Option "${option.value}" is not allowed and has been disabled.`);
          } else {
            console.log(`Option "${option.value}" is allowed.`);
          }
        });
      } else {
        console.warn('Dropdown component not found.');
      }
    }
    if (optionsAlow?.depth.length > 0) {
      const radioGroup = document.querySelector(`.depth-area`);
      const labels = radioGroup.querySelectorAll('.card-radio-btn');
      labels.forEach((label) => {
        const input = label.querySelector('.card-input-element');
        const button = label.querySelector('.radio-card-body');
        const inputValue = input.value;
        if (!optionsAlow.depth.includes(inputValue)) {
          button.disabled = true;
          button.style.opacity = 0.3;
          button.style.cursor = 'auto';
        } else {
          button.disabled = false;
          button.style.opacity = 1;
          button.style.cursor = 'pointer';
        }
      });
      const dropdownComponent = document.querySelector(`.dropdown-depth-area`);
      if (dropdownComponent) {
        // Iterate over each option in the dropdown
        Array.from(dropdownComponent.options).forEach((option) => {
          if (!optionsAlow.depth.includes(option.value)) {
            // Disable the option
            option.disabled = true;

            // Alternatively, log a message for debugging
            console.log(`Option "${option.value}" is not allowed and has been disabled.`);
          } else {
            console.log(`Option "${option.value}" is allowed.`);
          }
        });
      } else {
        console.warn('Dropdown component not found.');
      }
    }
    if (optionsAlow?.door_width.length > 0) {
      const radioGroup = document.querySelector(`.door_width-area`);
      const labels = radioGroup.querySelectorAll('.card-radio-btn');
      labels.forEach((label) => {
        const input = label.querySelector('.card-input-element');
        const button = label.querySelector('.radio-card-body');
        const inputValue = input.value;
        if (!optionsAlow.door_width.includes(inputValue)) {
          button.disabled = true;
          button.style.opacity = 0.3;
          button.style.cursor = 'auto';
        } else {
          button.disabled = false;
          button.style.opacity = 1;
          button.style.cursor = 'pointer';
        }
      });
      const dropdownComponent = document.querySelector(`.dropdown-door_width-area`);
      if (dropdownComponent) {
        // Iterate over each option in the dropdown
        Array.from(dropdownComponent.options).forEach((option) => {
          if (!optionsAlow.door_width.includes(option.value)) {
            // Disable the option
            option.disabled = true;

            // Alternatively, log a message for debugging
            console.log(`Option "${option.value}" is not allowed and has been disabled.`);
          } else {
            console.log(`Option "${option.value}" is allowed.`);
          }
        });
      } else {
        console.warn('Dropdown component not found.');
      }
    }
    if (optionsAlow?.door_opens.length > 0) {
      const radioGroup = document.querySelector(`.door_opens-area`);
      const labels = radioGroup.querySelectorAll('.card-radio-btn');
      labels.forEach((label) => {
        const input = label.querySelector('.card-input-element');
        const button = label.querySelector('.radio-card-body');
        const inputValue = input.value;
        if (!optionsAlow.door_opens.includes(inputValue)) {
          button.disabled = true;
          button.style.opacity = 0.3;
          button.style.cursor = 'auto';
        } else {
          button.disabled = false;
          button.style.opacity = 1;
          button.style.cursor = 'pointer';
        }
      });
      const dropdownComponent = document.querySelector(`.dropdown-door_opens-area`);
      if (dropdownComponent) {
        // Iterate over each option in the dropdown
        Array.from(dropdownComponent.options).forEach((option) => {
          if (!optionsAlow.door_opens.includes(option.value)) {
            // Disable the option
            option.disabled = true;

            // Alternatively, log a message for debugging
            console.log(`Option "${option.value}" is not allowed and has been disabled.`);
          } else {
            console.log(`Option "${option.value}" is allowed.`);
          }
        });
      } else {
        console.warn('Dropdown component not found.');
      }
    }
    if (optionsAlow?.extras.length > 0) {
      const radioGroup = document.querySelector(`.extras-area`);
      const labels = radioGroup.querySelectorAll('.card-radio-btn');
      labels.forEach((label) => {
        const input = label.querySelector('.card-input-element');
        const button = label.querySelector('.radio-card-body');
        const inputValue = input.value;
        if (!optionsAlow.extras.includes(inputValue)) {
          button.disabled = true;
          button.style.opacity = 0.3;
          button.style.cursor = 'auto';
        } else {
          button.disabled = false;
          button.style.opacity = 1;
          button.style.cursor = 'pointer';
        }
      });

      const dropdownComponent = document.querySelector(`.dropdown-extras-area`);
      if (dropdownComponent) {
        // Iterate over each option in the dropdown
        Array.from(dropdownComponent.options).forEach((option) => {
          if (!optionsAlow.extras.includes(option.value)) {
            // Disable the option
            option.disabled = true;

            // Alternatively, log a message for debugging
            console.log(`Option "${option.value}" is not allowed and has been disabled.`);
          } else {
            console.log(`Option "${option.value}" is allowed.`);
          }
        });
      } else {
        console.warn('Dropdown component not found.');
      }
    }
  }

  getColorLabel(color) {
    if (color === '#C0A071') return 'Brushed Gold';
    if (color === '#48362B') return 'New Bronze';
    if (color === '#E7E7E7') return 'Chrome';
    if (color === '#181416') return 'Matte Black';
    if (color === '#B5B5B5') return 'Stainless Steel';
    if (color === '#553721') return 'Oil Rubbed Bronze';
    if (color === '#DBDBDB') return 'Frosted';
    if (color === '#FFFFFF') return 'Clear';
  }

  mapProductData(responseData) {
    const product = responseData.data.productByHandle;
    const productData = {
      handle: product.handle,
      id: product.id,
      title: product.title,
      vendor: product.vendor,
      productType: product.productType,
      totalInventory: product.totalInventory,
      tags: product.tags,
      status: product.status,
      variants: product.variants.nodes.map((variant) => ({
        id: variant.id,
        availableForSale: variant.availableForSale,
        barcode: variant.barcode,
        sku: variant.sku,
        // position: variant.position,
        taxable: variant.taxable,
        price: variant.price.amount,
        compareAtPrice: variant.compareAtPrice,
        productId: variant.product.id,
        inventoryQuantity: variant.quantityAvailable,
        isSaleProduct:
          variant.compareAtPrice !== null &&
          parseFloat(variant.compareAtPrice.amount) > parseFloat(variant.price.amount),
        // presentmentPrices: variant.presentmentPrices.nodes.map((prc) => ({
        //   price: prc.price ? `${prc.price.amount} ${prc.price.currencyCode}` : null,
        //   compareAtPrice: prc.compareAtPrice ? `${prc.compareAtPrice.amount} ${prc.compareAtPrice.currencyCode}` : null,
        // })),
      })),
      seo: {
        description: product.seo.description,
        title: product.seo.title,
      },
      images: product.images.nodes.map((image) => ({
        altText: image.altText,
        height: image.height,
        id: image.id,
        originalSrc: image.originalSrc,
        src: image.src,
        transformedSrc: image.transformedSrc,
        url: image.url,
        width: image.width,
      })),
      featuredImage: {
        altText: product.featuredImage.altText,
        height: product.featuredImage.height,
        id: product.featuredImage.id,
        originalSrc: product.featuredImage.originalSrc,
        src: product.featuredImage.src,
        transformedSrc: product.featuredImage.transformedSrc,
        url: product.featuredImage.url,
        width: product.featuredImage.width,
      },
      media: product.media.nodes.map((media) => ({
        alt: media.alt,
        id: media.id,
        mediaContentType: media.mediaContentType,
      })),
      metafields: (product.metafields || []).filter(Boolean).map(({ id, key, value, type }) => ({
        id,
        key,
        value,
        jsonValue: (() => {
          try {
            return JSON.parse(value);
          } catch {
            return value;
          }
        })(),
        type,
      })),
    };

    return productData;
  }
}

// Define the custom element
customElements.define('product-variant-builder', ProductVariantBuilder);

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM fully loaded and parsed');

  const labels = document.querySelectorAll('.card-radio-btn.color-radio');
  const tooltip = document.createElement('div');
  tooltip.className = 'tooltip';
  document.body.appendChild(tooltip);

  labels.forEach((label) => {
    const input = label.querySelector('input');
    const builder = new ProductVariantBuilder();

    const showTooltip = (e) => {
      const value = builder.getColorLabel(input.value);
      tooltip.textContent = value;
      tooltip.style.visibility = 'visible';
      tooltip.style.opacity = '1';
      tooltip.style.top = `${e.pageY - tooltip.offsetHeight - 5}px`;
      tooltip.style.left = `${e.pageX - tooltip.offsetWidth / 2}px`;
    };

    const hideTooltip = () => {
      tooltip.style.visibility = 'hidden';
      tooltip.style.opacity = '0';
    };

    // Attach event listeners to both the label and input
    label.addEventListener('mouseenter', showTooltip);
    label.addEventListener('mousemove', showTooltip);
    label.addEventListener('mouseleave', hideTooltip);

    input.addEventListener('mouseenter', showTooltip);
    input.addEventListener('mousemove', showTooltip);
    input.addEventListener('mouseleave', hideTooltip);
  });
});
